<template>
  <div class="valuesCard">
    <div>
      <div class="box_title">
        <h3>{{ valuesObject.title }}</h3>
      </div>
      <div class="box_picture">
        <img :src="imgUrl(valuesObject.imagePath)" :alt="valuesObject.title" />
      </div>
      <div class="box_content" id="box_contents">
        <p>
          {{ valuesObject.description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
var images = require.context("../assets/ValuesIcons/", false, /\.svg$|\.jpg$/);

export default {
  props: ["valuesObject"],

  methods: {
    imgUrl: function (path) {
      return images("./" + path);
    },
  },
};
</script>
<style>
.box_picture {
  height: 80px;
  width: 200px;
}

.valuesCard {
  display: flex;
  margin: 10px;
  padding: 20px 30px;
  width: 275px;
  background-color: rgb(20, 26, 60);
  box-shadow: 3px 3px 3px 1px lightgray;
  color: white;
}

.box_title {
  padding: top 10px;
  font-size: 22px;
}
.box_picture,
.box_content {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  padding-top: 15px;
}

.box_content {
  font-size: larger;
}

#box_contents {
  /*color: rgb(0,231,211)*/
  color: white;
}
</style>
